import { render, staticRenderFns } from "./SlotPicker.vue?vue&type=template&id=223991a8&"
import script from "./SlotPicker.vue?vue&type=script&lang=js&"
export * from "./SlotPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports